import React from 'react';

import { BigButton, Button } from '@components/Button';
import { useChats } from '@context/ChatsContext';
import { useAddOrOpenChatMutation } from '@db/Chats/Queries';
import { errorAlert } from '@helpers/Alert';
import { User } from '@types';

type MessageButtonProps = Omit<React.ComponentProps<typeof BigButton>, 'onPress' | 'children'> & {
  userDoc: Pick<User, 'userId' | 'displayName' | 'photoUrl'>;
  onPress: (chatId: string) => void;
};

export default function MessageButton({ userDoc, onPress, ...props }: MessageButtonProps) {
  const { chats } = useChats();
  const addOrOpenChatMutation = useAddOrOpenChatMutation({ chats });
  const loading = addOrOpenChatMutation.isPending;

  const _onPress = () => {
    if (loading) return;

    addOrOpenChatMutation.mutate(
      { users: [userDoc] },
      {
        onError: (error) => errorAlert(error, { onAction: _onPress }),
        onSuccess: (chatId) => onPress(chatId),
      }
    );
  };

  return (
    <Button
      loading={loading}
      disabled={loading}
      onPress={_onPress}
      uppercase={false}
      compact
      mode="contained"
      {...props}>
      Chat
    </Button>
  );
}
